"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _DescriptionWith3Columns = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/DescriptionWith3Columns");

var _DescriptionWith3Columns2 = _interopRequireDefault(_DescriptionWith3Columns);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _components = require("components");

var _glamor = require("glamor");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _utils = require("utils");

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

var _cloudFront = require("../../utils/cloudFront");

var cf_utils = _interopRequireWildcard(_cloudFront);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buttonsGroup = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(3)
});

var button = (0, _glamor.css)({
  marginLeft: (0, _css.unitRem)(1),
  width: (0, _css.unitRem)(9.5),

  ":first-child": {
    marginLeft: 0
  }
});

var Megascans = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    loggedIn: state.auth.loggedIn
  };
}), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(Megascans, _React$Component);

  function Megascans(props) {
    (0, _classCallCheck3.default)(this, Megascans);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Megascans.__proto__ || (0, _getPrototypeOf2.default)(Megascans)).call(this, props));

    _this.state = {
      platform: "Windows"
    };
    return _this;
  }

  (0, _createClass3.default)(Megascans, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var platform = (0, _utils.detectOperatingSystem)();
      this.setState({ platform: platform });
    }
  }, {
    key: "render",
    value: function render() {
      var loggedIn = this.props.loggedIn;
      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: "Megascans - #1 choice for games, VFX, archviz and beyond",
          documentImage: cf_utils.cf_thumbs("shareimage-ms.jpg"),
          documentDescription: "Megascans is the world's largest 3D asset scans library full of high-resolution, PBR-calibrated surfaces, vegetation and modular scanned assets." },
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(_components.Hero, {
            opacity: 0.25,
            bg: cf_utils.cf_qx_page("megascans", "Megascans_First_Frame.jpeg"),
            backgroundVideo: {
              poster: cf_utils.cf_qx_page("megascans", "Megascans_First_Frame.jpeg"),
              loop: "true",
              src: cf_utils.cf_qx_page("megascans", "Megascans-Website-Aspen.mp4")
            },
            superIconUrls: [cf_utils.cf_icons("megascans_icon_2048_preview.png")],
            primaryLabel: "",
            primaryTo: "",
            title: "MEGASCANS",
            subTitle: "#1 CHOICE FOR GAMES, VFX, ARCHVIZ AND BEYOND",
            secondaryLabel: this.props.loggedIn ? "MY SCANS" : "Go TO FAB",
            secondaryTo: this.props.loggedIn ? "/megascans/purchased" : _config2.default.quixelOnFabURL,
            linkIcon: "rightSide",
            artist: "RENDERED IN UNREAL ENGINE 5"
          }),
          _react2.default.createElement(_DescriptionWith3Columns2.default, {
            title: "WHAT IS MEGASCANS",
            headingBeforeBreak: "#1 CHOICE FOR GAMES, VFX",
            headingAfterBreak: "ARCHVIZ AND BEYOND",
            columns: [{
              img: cf_utils.cf_icons("world_class_capture.svg"),
              isIcon: false,
              title: "World-class capture",
              desc: "All 3D and 2D assets are scanned based on your immediate needs, so you can focus on being creative."
            }, {
              img: cf_utils.cf_icons("instant_quality.svg"),
              isIcon: false,
              title: "Premium quality",
              desc: "Thanks to its incredible quality and depth, Megascans makes work fun & easy for the world’s top AAA and VFX studios."
            }, {
              img: cf_utils.cf_icons("industry_standard.svg"),
              isIcon: false,
              title: "Fully standardized",
              desc: "Optimized topology, UVs and LODs, consistent scale, resolution, and real-world PBR: the boring stuff is done for you."
            }]
          }),
          _react2.default.createElement(_components.Feature, {
            newHome: true,
            featureType: "MEGASCANS",
            img: cf_utils.cf_qx_page("megascans", "1_3D_Assets.jpg"),
            images: [cf_utils.cf_qx_page("megascans", "1_3D_Assets.jpg"), cf_utils.cf_qx_page("megascans", "2_Surfaces.jpg"), cf_utils.cf_qx_page("megascans", "3_Vegetation.jpg"), cf_utils.cf_qx_page("megascans", "4_Imperfections.jpg"), cf_utils.cf_qx_page("megascans", "5_Atlases.jpg"), cf_utils.cf_qx_page("megascans", "6_Decals.jpg")],
            title: "Industry-leading excellence",
            desc: "Thousands of high-quality 3D assets, tileable surfaces, vegetation, imperfections, atlases, decals, and more, all at your fingertips. With a library that's constantly updated, you'll always have access to the assets you need to bring your projects to life - fast. Focus on what matters most: your creativity."
          }),
          _react2.default.createElement(_components.Feature, {
            flip: true,
            featureType: "MEGASCANS",
            img: cf_utils.cf_qx_page("megascans", "go_beyond_photorealism_UE5.jpeg"),
            title: "Go beyond photorealism",
            newHome: true,
            desc: "Years of research, innovation, and engineering have gone into creating Megascans, combining cutting-edge scanning hardware and processing software to achieve unparalleled photorealism. Instantly get rid of the  plastic look of low-quality 3D scans, and push yourself far beyond just photorealism.",
            artist: "Josef Bsharah"
          }),
          _react2.default.createElement(_components.Feature, {
            featureType: "MEGASCANS",
            img: cf_utils.cf_qx_page("megascans", "megascans-no-more-guesswork.jpg"),
            title: "Skip guesswork",
            newHome: true,
            desc: "Megascans is the definitive standardized content resource. All assets are consistently scanned, scaled and PBR calibrated, and every single 3D mesh comes with meticulously optimized topology, UVs and LODs, meaning you can spend less time doing boring work, and more time having fun creating expansive worlds."
          }),
          _react2.default.createElement(
            "div",
            {
              className: (0, _glamor.css)({
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "4rem 2rem 6rem"
              }) },
            _react2.default.createElement(_Button2.default, { mode: "secondary", label: "Explore Megascans on FAB", href: _config2.default.quixelOnFabURL })
          )
        )
      );
    }
  }]);
  return Megascans;
}(_react2.default.Component)) || _class);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.user
  };
})(Megascans);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Apps/Megascans.jsx
// module id = 2883
// module chunks = 0